import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import parse from 'urlencoded-body-parser'
import { ImportCitationContainer } from '@chegg-wt/core/components/ImportCitationContainer'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import withApollo from '@chegg-wt/core/api/graphApi'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'

interface ImportPageProps {
  rawCitationsData: string
}

const ImportPage: NextPage<ImportPageProps> = ({ rawCitationsData }) => {
  useOnUnloadTimeOnPage()
  return <ImportCitationContainer rawCitationsData={rawCitationsData} isPremiumFlow />
}

export const getServerSideProps: GetServerSideProps<ImportPageProps> = async ({
  req,
}) => {
  let rawBody = null
  if (req.method === 'POST') {
    try {
      rawBody = await parse(req)
    } catch (err) {
      trackWithoutThrow(err)
    }
  }
  return {
    props: {
      rawCitationsData: rawBody?.records ?? null,
    },
  }
}

export default withApollo({ ssr: false })(ImportPage)
